module.exports = __webpack_public_path__ + "main/assets/public/discount-code/clipboard-icon.f00130444839bf62.svg";